import * as React from 'react'; 
import { any } from 'prop-types';
import {dayToLabel} from '../../utils/day-to-label';

export default function DailyNavigation({onRequestNext, onRequestPrev, date}){
   return (
      <div className="flex justify-between mb-3">
        <div>
          {dayToLabel(date.getDay())}, {date.getDate()}/{date.getMonth() + 1}
        </div>
        <div>
           <button className="rounded shadow bg-white px-2 rounded-full mx-1" onClick={onRequestPrev}>
             &larr;
           </button>
           <button className="rounded shadow bg-white px-2 rounded-full mx-1" onClick={onRequestNext}>
             &rarr;
           </button>
        </div>
      </div>
   )
}

DailyNavigation.defaultProps = {
  date: new Date() 
}

DailyNavigation.propTypes = {
  onRequestNext: any,
  onRequestPrev: any,
  date: any,
}
